import { createStore, createEffect, createEvent, combine } from 'effector';
import { $notificationStore } from '../notificationStore';
import { ApiUtils } from '@shared/utils';
import { ProfileApi, type UpdateAddressRequest } from '@shared/api';

const updateAddressEffect = createEffect((data: UpdateAddressRequest) => ProfileApi.updateAddress(data));
const clearEvent = createEvent();

const $dataStore = createStore<string>('')
  .on(updateAddressEffect.done, (_, data) => data.result.data ?? '')
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(updateAddressEffect.pending, (_, data) => data)
  .on(updateAddressEffect.fail, () => false)
  .on(updateAddressEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(updateAddressEffect, () => null)
  .on(
    updateAddressEffect.fail,
    (_, data) => ApiUtils.getApiErrorData(data.error, 'Something went wrong while updating Address. Please try again.').message,
  )
  .on(updateAddressEffect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((error) => $notificationStore.events.setError(error));

export const $updateAddressStore = {
  events: {
    updateAddress: updateAddressEffect,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
